module.exports = __webpack_public_path__ + "static/media/family.fd5cf817.svg";